 
import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

export default function ElectionTab({
  latestStoryData = null,
  latestVideoData = null,
  categoryNewsListData = null,
  constituencyListData = null,
  candidateData = null,
  constHindiName = null,
  constituencyDetailData = null,
  electionCategory = null,
  ConstituencyliveBlogData = null,
}) {
  const isMobileDevice = useIsMobile();
  
  let metaData

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          // electionPath="delhi-assembly/constituency-list"
          electionPath={`${electionCategory}/constituency-list`}
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          constituencyListData={constituencyListData}
          candidateData={candidateData}
          constHindiName={constHindiName}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="tamil_nadu_election"
          stateName={"Tamil Nadu"} //"Delhi"
          stateHindi={"तमिळ नाडु"}
          metaData={metaData}
          constituencyDetailData={constituencyDetailData}
          
          ConstituencyliveBlogData={ConstituencyliveBlogData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;

    let pathParts = url.replace("/elections/", "").split("/");

    let electionCategory = `${pathParts[0]}/${pathParts[1]}`;
    const getUrl = `/elections/${electionCategory}`;
    console.log("getUrl--", getUrl);
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { MasterConfigContext } = await import(
      "@/context/MasterConfigContext"
    );
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");

    const unixtime = getUnixTimeDaysAgo(15);

    const masterConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    let electionConfig = masterConfig?.data;

    // const electionConfig = useContext(MasterConfigContext);

    // console.log("the elction config is" , electionConfig)

    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: getUrl, // url,
        page: page,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let constituencyListData = null;

    let constituencyUrl = `https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/tamil-nadu-state-master.json?v=1763056986`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("constituencyListData", data1?.data);
      constituencyListData = data1?.data;
    });

    let constId = ctx?.resolvedUrl?.split("?")[0].split("-").pop();

    let constHindiName =
      constituencyListData &&
      constituencyListData?.filter(
        (item) => parseInt(item?.cons_id) === parseInt(constId)
      )[0]?.cons_name_hi;

    let candidateData = null;
    let constituencyDetailData = null;

    // let candidateUrl = `https://akm-img-a-in.tosshub.com/sites/elections/2025/assembly/json/constituency/bihar/${constId}.json`;
   let candidateUrl = `https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/constituency/tamil-nadu/${constId}.json?v=1763056986`;
    await fetch(candidateUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const tempCand = await data.json();

      candidateData = tempCand?.data?.candidate || null;
      constituencyDetailData = tempCand?.data || null;
    }).catch((err) => {
      logger.error("Error fetching candidate data:", err);
      candidateData = null;
      constituencyDetailData = null;
    });

    // constituency live blog api-----------------------------------------------
    let ConstituencyliveBlogData = null;
    let ConstituencyliveBlogUrl = `${process.env.BASE_PATH}/nwtak/api/get-election-constituency-data?id=${constId}`;

    try {
      const response = await fetch(ConstituencyliveBlogUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const tempCand = await response.json();

      if (tempCand?.status_code === 0 || !tempCand?.data) {
        ConstituencyliveBlogData = null;
      } else {
        ConstituencyliveBlogData = tempCand.data;
      }
    } catch (err) {
      console.error(err);
      ConstituencyliveBlogData = null;
    }

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      //  faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: getUrl, // url,
          page: page,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 60);
    // console.log("categoryNewsListData", categoryNewsListData);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        constituencyListData,
        candidateData,
        constHindiName,
        constituencyDetailData,
        electionCategory,
        // faqData,
        ConstituencyliveBlogData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
